import { render, staticRenderFns } from "./TrackersTabsComponent.vue?vue&type=template&id=47250b30"
import script from "./TrackersTabsComponent.vue?vue&type=script&lang=js"
export * from "./TrackersTabsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports